export default __webpack_public_path__ + "static/media/analytics-bar-chart-svgrepo-com.fdbfaa54.svg";